module.exports = __webpack_public_path__ + "static/media/08_DCV-2018A-5AX.9ba425c1.png";